import { AuthRole } from '@/enums/roles';
import GlobalSources from '@/views/sources/GlobalSources.vue';
import SuperAdminEmployees from '@/views/superAdmin/SuperAdminEmployees.vue';
import SuperAdminOrganizations from '@/views/superAdmin/SuperAdminOrganizations.vue';
import SuperAdminOverview from '@/views/superAdmin/SuperAdminOverview.vue';
import Teams from '@/views/teams/Teams.vue';
import type { RouteRecordRaw } from 'vue-router';

const routes: readonly RouteRecordRaw[] = [
    {
        path: '/hoofdbeheer',
        name: 'superadmin',
        component: SuperAdminOverview,
        meta: {
            pageTitle: 'Hoofdbeheer',
            roles: [AuthRole.SuperAdmin]
        }
    },
    {
        path: '/hoofdbeheer/medewerkers',
        name: 'superadmin-employees',
        component: SuperAdminEmployees,
        meta: {
            pageTitle: 'Hoofdbeheer | Medewerkers',
            roles: [AuthRole.SuperAdmin]
        }
    },
    {
        path: '/hoofdbeheer/teams',
        name: 'superadmin-teams',
        component: Teams,
        meta: {
            pageTitle: 'Hoofdbeheer | Teams',
            roles: [AuthRole.SuperAdmin]
        }
    },
    {
        path: '/hoofdbeheer/bedrijven',
        name: 'superadmin-organizations',
        component: SuperAdminOrganizations,
        meta: {
            pageTitle: 'Alle bedrijven',
            roles: [AuthRole.SuperAdmin]
        }
    },

    {
        path: '/hoofdbeheer/bronnen',
        name: 'superadmin-sources',
        component: GlobalSources,
        meta: {
            pageTitle: `Globale bronnen`,
            roles: [AuthRole.SuperAdmin]
        }
    }
];

export default routes;
